import React from "react";

const fmt = (n) => (n || 0).toLocaleString("es-AR");
const OSWALD = "'Oswald', sans-serif";

const Row = ({ label, value }) => (
  <div style={{ display: "flex", justifyContent: "space-between", padding: "18px 0", borderBottom: "2px solid rgba(255,255,255,0.12)", fontSize: 36 }}>
    <span style={{ color: "rgba(255,255,255,0.7)", textTransform: "uppercase", letterSpacing: 3, fontFamily: OSWALD }}>{label}</span>
    <span style={{ color: "#fff", fontWeight: 700, fontFamily: OSWALD }}>{fmt(value)} <span style={{ color: "#F5B400", fontSize: 26 }}>PVA</span></span>
  </div>
);

const headline = (r) => {
  if (r.recibe_ya) return ["ME TOCA", "YA"];
  if (r.es_piloto_automatico) return ["ME TOCA", "A LOS 18"];
  return ["ME TOCA EN", `${(r.mes_recepcion || "").toUpperCase()} · AÑO ${r.ano_recepcion}`];
};

export default function SimulatorStoryCard({ result }) {
  const [l1, l2] = headline(result);
  return (
    <div data-testid="story-card" style={{ width: 1080, height: 1920, background: "#0A192F", color: "#fff", padding: "120px 96px", boxSizing: "border-box", display: "flex", flexDirection: "column", fontFamily: "sans-serif", position: "relative", overflow: "hidden" }}>
      <div style={{ position: "absolute", top: -200, right: -200, width: 700, height: 700, borderRadius: "50%", background: "rgba(245,180,0,0.18)" }} />
      <div style={{ position: "absolute", bottom: -260, left: -220, width: 760, height: 760, borderRadius: "50%", background: "rgba(37,99,235,0.22)" }} />
      <div style={{ position: "relative", display: "flex", alignItems: "center", gap: 24 }}>
        <span style={{ width: 80, height: 6, background: "#F5B400", display: "inline-block" }} />
        <span style={{ fontFamily: OSWALD, fontSize: 38, letterSpacing: 10, color: "#F5B400", textTransform: "uppercase" }}>Frente Ya · Capital Ciudadano</span>
      </div>
      <div style={{ position: "relative", marginTop: 90, fontFamily: OSWALD, fontWeight: 700, textTransform: "uppercase", lineHeight: 1 }}>
        <div style={{ fontSize: 110 }}>{l1}</div>
        <div style={{ fontSize: result.recibe_ya ? 200 : 96, color: "#F5B400", marginTop: 20 }}>{l2}</div>
        {result.recibe_ya && (
          <div style={{ fontSize: 40, marginTop: 24, color: "rgba(255,255,255,0.85)", letterSpacing: 2 }}>
            Por arraigar en {result.arraigo === "pueblo_pequeno" ? "un pueblo del interior" : "una ciudad chica"}
          </div>
        )}
      </div>
      <div style={{ position: "relative", marginTop: 70 }}>
        <div style={{ fontFamily: OSWALD, fontSize: 36, letterSpacing: 6, color: "rgba(255,255,255,0.6)", textTransform: "uppercase" }}>Mi patrimonio base</div>
        <div style={{ fontFamily: OSWALD, fontWeight: 700, fontSize: 180, lineHeight: 1.2 }}>
          {fmt(result.total_pva)}<span style={{ fontSize: 70, color: "#F5B400", marginLeft: 20 }}>PVA</span>
        </div>
        <div style={{ fontSize: 34, color: "rgba(255,255,255,0.75)", marginTop: 24 }}>para comprar mi casa. Sin crédito, sin cuotas, sin intereses.</div>
      </div>
      <div style={{ position: "relative", marginTop: 50, marginBottom: 60 }}>
        <Row label="Vivienda" value={result.base_vivienda_pva + (result.bonus_convivencia_pva || 0) + (result.arraigo_bonus_pva || 0)} />
        <Row label="Equipamiento" value={result.base_equipamiento_pva} />
        <Row label="Turismo nacional" value={result.bonus_turismo_pva} />
      </div>
      <div style={{ position: "relative", marginTop: "auto", background: "#F5B400", color: "#0A192F", padding: "48px 56px" }}>
        <div style={{ fontFamily: OSWALD, fontWeight: 700, fontSize: 64, textTransform: "uppercase", lineHeight: 1.1 }}>¿Y a vos cuánto te toca?</div>
        <div style={{ fontSize: 40, marginTop: 12, fontWeight: 600 }}>Calculalo en frenteya.com.ar</div>
      </div>
    </div>
  );
}
